import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PublicIcon from '@mui/icons-material/Public';
import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';
import PackageStatus from 'components/PackageStatus';

import { PackageSidebar_package$key } from '__generated__/PackageSidebar_package.graphql';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { PUBLIC_URL } from 'const';

type Props = {
  package: PackageSidebar_package$key;
};

const PackageSidebar: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageSidebar_package on Package {
        link

        ...EntitySidebar_entity
        ...PackageStatus_package
        ...PackageAutoHotelPriceUpdateSwitch_package
      }
    `,
    props.package
  );

  return (
    <EntitySidebar entity={pack}>
      <SidebarBox label="Būsena:">
        <PackageStatus package={pack} />
      </SidebarBox>

      <Divider />

      <SidebarBox icon={PublicIcon}>
        <Link
          href={`${PUBLIC_URL}${pack.link}`}
          target="_blank"
          rel="noreferrer">
          Kelionės puslapis svetainėje
        </Link>
      </SidebarBox>

      {/* {false && (
        <>
          <SidebarBox>
            <PackageAutoHotelPriceUpdateSwitch package={pack} />
          </SidebarBox>

          <Divider />
        </>
      )} */}
    </EntitySidebar>
  );
};

export default PackageSidebar;
